/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `index.html`.
 */

import { App } from "@/App";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { AuthProvider } from "@/context/AuthContext"; // Import AuthProvider
import "@/index.css"; // Import CSS
import { initializeTelegramWebApp } from "@/lib/telegramUtils";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

function start() {
  // Initialize Telegram WebApp features early
  initializeTelegramWebApp();

  const root = createRoot(document.getElementById("root")!);
  // Wrap App with ErrorBoundary and AuthProvider
  root.render(
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
